import React, { useEffect, useState, useMemo } from 'react';
import { Button, MenuItem } from '@mui/material';
import TextField from '../../../../components/common/InputField/TextField';
import { useSelector } from 'react-redux';

export const usePositionDialogContent = (props) => {
    const { data, actionType, setActionType, handleConfirm, type } = props;
    const [payload, setPayload] = useState({});
    const { selectedPositions } = useSelector((state) => state.preHQPositions);

    const handleSubmit = (data) => {
        handleConfirm({ ...payload });
    };

    useEffect(() => {
        if (actionType === 'map-review-policy') return setPayload({ reviewPolicyId: data?.reviewPolicy?.id });
        return setPayload({});
    }, [actionType, data]);

    const dialogContent = useMemo(() => {
        if (actionType === 'send_for_approval') {
            return {
                title: 'Send for Review',
                confirmation:
                    type === 'bulk'
                        ? `Are you sure you want to send ${selectedPositions.length} ${selectedPositions.length > 1 ? 'positions' : 'position'} to review?`
                        : `Are you sure you want to send this position for review?`,
                actions: (
                    <React.Fragment>
                        <Button size="large" onClick={() => setActionType()}>
                            Cancel
                        </Button>
                        <Button size="large" variant="contained" onClick={handleSubmit}>
                            Confirm
                        </Button>
                    </React.Fragment>
                ),
            };
        }
        return null;
    }, [data, payload, actionType, setActionType, selectedPositions.length]);

    return dialogContent;
};
